module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABG0lEQVQ4T6WTUVEDQRBEXysAB1QcBAUQBYADUAAoICggDkBCHAAKiITgABQ01Vu7V5sjFz6Yr6uZ2Te9vXPin6FD522/AZa0mOr7C+AclDTZt1OwfQ08AY+SVrYHgO0X4AK4l5TvEgPA9jnwWvNXktYjQODPtX4qaTMGbIET4KZN6AFprgoD2UqaDYBu+rukKCkxBtRcjD0DiopyBdtL4KHeb9UBvqqJx12u9can5RiwkJQJTUFRsycXr3YAd537mTAZY7VNwRz46M2ZIthuZs8kbftnbOYUafsAtuPPLTCY3QOiIpAjYF3vWN7admox+RL4BuaZvrMHXWMOZx/2xWcgbYl+ATr3Y2qmZXIiStZZ7zH14M906DVa7Qcvs5MRMSbqBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logOut.png
// module id = YOOP
// module chunks = 1